import { Component, computed, OnInit, signal } from '@angular/core';
import { TuiDataList, TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { ImportTypeString } from '../import-features/import-features.component';
import { CommonModule } from '@angular/common';
import { TuiInputModule, TuiSelectModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';
import { TuiDataListWrapper } from '@taiga-ui/kit';
import { FormsModule } from '@angular/forms';

export interface featureImportMetadata {
  featureCount: number;
  commonAttributeNames: string[];
}

@Component({
  selector: 'app-features-imported',
  templateUrl: './features-imported.component.html',
  styleUrls: ['./features-imported.component.css'],
  imports: [CommonModule, FormsModule, TuiInputModule,        TuiDataList,
    TuiDataListWrapper,
    TuiSelectModule,
    TuiTextfieldControllerModule,]
})
export class FeaturesImportedComponent implements OnInit {


    public readonly context = injectContext<TuiDialogContext<{typedPrefix: string | null, selectedAttribute: string | null}, {metadata: featureImportMetadata} >>();

    metadata = signal<featureImportMetadata>(this.context.data.metadata);

    typedPrefix = signal<string | null>(null);
    selectedAttribute = signal<string | null>(null)

    canSubmit = computed(() => {
      const typedPrefix = this.typedPrefix();

      const selectedAttribute = this.selectedAttribute();


      return (typedPrefix != null || selectedAttribute != null) ? true : false;
    })


  constructor() { }

  ngOnInit() {
  }

  submit()
  {
    const typedPrefix = this.typedPrefix();

    const selectedAttribute = this.selectedAttribute();


    this.context.completeWith({typedPrefix, selectedAttribute })
  }

}
